import React from "react";
import { Grid, Radio } from "@sumprio/ui";
import { RequiredFieldLabel } from "../RequiredFieldLabel";
import type { DocumentUploadMode } from "./types";

export interface DocumentUploadModeFieldProps {
  value: DocumentUploadMode;
  onChange: (_nextMode: DocumentUploadMode) => void;
  /** Unique radio group name when multiple instances exist on a page. */
  name?: string;
  disabled?: boolean;
}

export function DocumentUploadModeField({
  value,
  onChange,
  name = "document-upload-mode",
  disabled = false,
}: DocumentUploadModeFieldProps) {
  return (
    <Grid display="flex" flexDirection="column" gap="sm">
      <RequiredFieldLabel label="How do you want to upload?" />
      <Grid display="flex" flexDirection="column" gap="sm" marginTop="xs">
        <Radio
          name={name}
          value="bundle"
          label="One document (multiple pages/sections)"
          checked={value === "bundle"}
          onChange={() => onChange("bundle")}
          size="sm"
          disabled={disabled}
        />
        <Radio
          name={name}
          value="separate"
          label="Separate documents (one row per file)"
          checked={value === "separate"}
          onChange={() => onChange("separate")}
          size="sm"
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
}
